import {FINANCIAL_ADVISER_ID} from "../__constants__";
import {
    logoBlackrockBlack,
    logoTimeInvestments,
    bgTimeInvestmentsMobile,
    bgBlackrockMobile,
    bgTimeInvestmentsDesktop,
    bgBlackrockDesktop,
    bgPensionsDesktop,
    bgPensionsMobile,
    bgRetirementDesktop,
    bgRetirementMobile,
    logoFundment,
    bgFinancialPlanningDesktop, bgFinancialPlanningMobile
} from "../assets/images";

export const SERVICE_ID_INVESTMENTS_AND_SAVINGS = 397;
export const SERVICE_ID_INHERITANCE_PLANNING = 558;
export const SERVICE_ID_PENSIONS = 393;
export const SERVICE_ID_RETIREMENT_INCOME = 395;
export const SERVICE_ID_FINANCIAL_PLANNING = 641;
export const NUMBER_OF_BANNER_SLOTS = 2;

export const providerBanners = [
    {
        id: 1,
        attribute: {
            id: SERVICE_ID_INVESTMENTS_AND_SAVINGS
        },
        title: 'Want to understand more about investing?',
        text: 'Download our short explainer now',
        logo: logoBlackrockBlack,
        logoHeight: 27,
        logoWidth: 181,
        logoHeightMobile: 20,
        logoWidthMobile: 134,
        bgImageDesktop: bgBlackrockDesktop,
        bgImageDesktopHeight: 560,
        bgImageDesktopWidth: 1578,
        bgImageMobile: bgBlackrockMobile,
        bgImageMobileHeight: 338,
        bgImageMobileWidth: 1157,
        name: 'Blackrock Black',
        url: 'https://explainer.vouchedfor.co.uk/investment?utm_source=consumer&utm_medium=banner',
        sponsored: true
    },
    {
        id: 2,
        attribute: {
            id: SERVICE_ID_INHERITANCE_PLANNING
        },
        title: 'Want to understand more about inheritance tax?',
        text: 'Download our short explainer now',
        logo: logoTimeInvestments,
        logoHeight: 27,
        logoWidth: 90,
        logoHeightMobile: 20,
        logoWidthMobile: 73,
        bgImageDesktop: bgTimeInvestmentsDesktop,
        bgImageDesktopHeight: 500,
        bgImageDesktopWidth: 1758,
        bgImageMobile: bgTimeInvestmentsMobile,
        bgImageMobileHeight: 256,
        bgImageMobileWidth: 1135,
        name: 'Time Investments',
        url: 'https://explainer.vouchedfor.co.uk/inheritance-explainer?utm_source=consumer&utm_medium=banner',
        sponsored: true
    },
    {
        id: 3,
        attribute: {
            id: SERVICE_ID_PENSIONS
        },
        title: 'Want to understand more about pensions?',
        text: 'Download our short explainer now',
        logo: null,
        logoHeight: 0,
        logoWidth: 0,
        logoHeightMobile: 20,
        logoWidthMobile: 73,
        bgImageDesktop: bgPensionsDesktop,
        bgImageDesktopHeight: 200,
        bgImageDesktopWidth: 265,
        bgImageMobile: bgPensionsMobile,
        bgImageMobileHeight: 108,
        bgImageMobileWidth: 118,
        name: 'Pensions',
        url: 'https://explainer.vouchedfor.co.uk/pension?utm_source=consumer&utm_medium=banner',
        sponsored: false
    },
    {
        id: 4,
        attribute: {
            id: SERVICE_ID_RETIREMENT_INCOME
        },
        title: <span>Want to understand more about <br />retirement income?</span>,
        text: 'Download our short explainer now',
        logo: null,
        logoHeight: 0,
        logoWidth: 0,
        logoHeightMobile: 20,
        logoWidthMobile: 73,
        bgImageDesktop: bgRetirementDesktop,
        bgImageDesktopHeight: 240,
        bgImageDesktopWidth: 393,
        bgImageMobile: bgRetirementMobile,
        bgImageMobileHeight: 120,
        bgImageMobileWidth: 155,
        name: 'Retirement Income',
        url: 'https://explainer.vouchedfor.co.uk/retirement?utm_source=consumer&utm_medium=banner',
        sponsored: false
    },
    {
        id: 5,
        attribute: {
            id: SERVICE_ID_FINANCIAL_PLANNING
        },
        title: <span>Want to understand more about <br/>financial planning?</span>,
        text: 'Download our short explainer now',
        logo: logoFundment,
        logoHeight: 27,
        logoWidth: 116,
        logoHeightMobile: 27,
        logoWidthMobile: 116,
        bgImageDesktop: bgFinancialPlanningDesktop,
        bgImageDesktopHeight: 240,
        bgImageDesktopWidth: 386,
        bgImageMobile: bgFinancialPlanningMobile,
        bgImageMobileHeight: 100,
        bgImageMobileWidth: 248,
        name: 'Fundment',
        url: 'https://explainer.vouchedfor.co.uk/financial-planning?utm_source=consumer&utm_medium=banner',
        sponsored: true
    },
]

export function getProviderList()
{
    return providerBanners
}

export function getBanners(serviceList, providerBannerList, verticalId) {
    if (verticalId !== FINANCIAL_ADVISER_ID) {
        return []
    }

    const providerBanners = new Map();
    providerBannerList.forEach(item => {
        providerBanners.set(item.attribute.id, item)
    })

    return getSlots(serviceList, providerBanners);
}

function getSlots(serviceList, providerBanners) {
    const takenSlotsSponsored = []
    const takenSlotsNotSponsored = []

    if (serviceList.length === 0) {
        const banner = providerBanners.get(SERVICE_ID_INVESTMENTS_AND_SAVINGS)
        return [banner]
    }

    for (const key in serviceList) {
        if (!providerBanners.has(serviceList[key])) {
            continue
        }

        const banner = providerBanners.get(serviceList[key])

        if (banner.sponsored) {
            takenSlotsSponsored.push(banner)
            continue
        }

        takenSlotsNotSponsored.push(banner)
    }

    return [...takenSlotsSponsored, ...takenSlotsNotSponsored].slice(0, 2)
}